import AbstractEditable from "../editable/abstract";
import CheckboxEditable from "../editable/checkbox";
import ColorEditable from "../editable/color";
import DateEditable from "../editable/date";
import DateTimeEditable from "../editable/date_time";
import TextEditable from "../editable/text";
import TextareaEditable from "../editable/textarea";
import ToggleEditable from "../editable/toggle";
import FullnameEditable from "../editable/fullname";
import SelectEditable from "../editable/select";
import Select2Editable from "../editable/select2_dropdown";
import WPLibraryEditable from "../editable/media";
import MultiInputEditable from "../editable/multi_input";
import TaxonomyEditable from "../editable/taxonomy";
import WysiwygEditable from "../editable/wysiwyg";
var Editables = /** @class */ (function () {
    function Editables() {
        this.editables = {};
    }
    Editables.prototype.initEditables = function () {
        this.editables._abstract = AbstractEditable;
        this.editables.text = TextEditable;
        this.editables.textarea = TextareaEditable;
        this.editables.number = TextEditable;
        this.editables.checklist = CheckboxEditable;
        this.editables.color = ColorEditable;
        this.editables.select = SelectEditable;
        this.editables.select2 = Select2Editable;
        this.editables.date = DateEditable;
        this.editables.fullname = FullnameEditable;
        this.editables.date_time = DateTimeEditable;
        this.editables.toggle = ToggleEditable;
        this.editables.wp_library = WPLibraryEditable;
        this.editables.multi_input = MultiInputEditable;
        this.editables.taxonomy = TaxonomyEditable;
        this.editables.wysiwyg = WysiwygEditable;
        document.dispatchEvent(new CustomEvent('AC_Editing_Register_Editables', { detail: this }));
    };
    Editables.prototype.registerEditable = function (name, object) {
        this.editables[name] = object;
        return this;
    };
    Editables.prototype.get = function (type) {
        if (!this.editables.hasOwnProperty(type)) {
            return false;
        }
        return this.editables[type];
    };
    Editables.prototype.abstract = function () {
        return this.get('_abstract');
    };
    return Editables;
}());
export default Editables;
